import { useState, useEffect } from "react";
import { Chart } from "react-google-charts";
import cdpService from "../../../apiService/cdp.service";

export const TotalUsersOption = {
    pieHole: 0.6,
    is3D: false,
    legend: "none",
    format:'decimal',
    slices: {
        0: { color: "#da251d" },
        1: { color: "#ff00c6" },
    },
    chartArea: {
        left: 10,
        right: 10,
        bottom: 20,
        top: 20,
        width: "100%",
        height: "100%",
    },
};

const ProductChart = () => {
    const [productData, setProductData] = useState([]);
    const [tabs, setTabs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        cdpService
            .getProductChart()
            .then((response) => response.data)
            .then((data) => {
                if (data.success && data.data.productWiseData) {
                    const formattedChartData = [
                        ["Product", "Total Users"],
                        ...data.data.productWiseData.map((item) => [
                            item.product_name,
                            item.customer_count,
                        ]),
                    ];

                    const formattedTabs = data.data.productWiseData.map((item, index) => ({
                        id: index + 1,
                        name: item.product_name,
                        stat: item.customer_count.toLocaleString(),
                        image: item.image_url,
                        percentage: item.customer_percentage.toFixed(2) + "%",
                        current: index === 0, // Highlight first tab
                    }));

                    setProductData(formattedChartData);
                    setTabs(formattedTabs);
                }
                setLoading(false);
            })
            .catch((error) => {
                setError(error);
                setLoading(false);
            });
    }, []);

    // if (loading) return <p>Loading chart...</p>;
    if (error) return <p>Error loading data.</p>;

    return (
        <>
            {loading ? <>
                <div className="col-span-1 animate-pulse">
                    <div className="h-[260px] w-[260px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                </div>
                <div className="col-span-1 grid grid-cols-1 lg:grid-cols-1 gap-1 ps-8 animate-pulse">
                    <div className="h-16 w-full bg-gray-200 rounded-lg dark:bg-gray-700"></div>
                    <div className="h-16 w-full bg-gray-200 rounded-lg dark:bg-gray-700"></div>
                    <div className="h-16 w-full bg-gray-200 rounded-lg dark:bg-gray-700"></div>
                    <div className="h-16 w-full bg-gray-200 rounded-lg dark:bg-gray-700"></div>
                </div>
            </> : <>
                {/* Pie Chart Section */}
                <div className="col-span-1">
                    <Chart
                        chartType="PieChart"
                        width="100%"
                        height="300px"
                        data={productData}
                        options={TotalUsersOption} // ✅ Applied Here
                    />
                </div>
                {/* Product List Section */}
                <div className="col-span-1 grid grid-cols-1 lg:grid-cols-1 gap-1 overflow-auto h-64 ps-8">
                    {tabs.map((item) => (
                        <div key={item.id} className="border rounded-lg flex items-center">
                            <img src={item.image} alt={item.name} className="w-14 h-14 ms-3" />
                            <div className="ml-4">
                                <p className="text-[10px] font-medium text-gray-700 mt-2">{item.name}</p>
                                <p className="text-sm font-bold text-gray-900">{item.stat} <small className="text-gray-500">{item.percentage}</small></p>
                            </div>
                        </div>
                    ))}
                </div>
            </>}
        </>
    );
};

export default ProductChart;
